Foundation.Login.Dialog.FeelingShyComponent = class extends Foundation.Component {
  /**
   * @param {string} id
   */
  constructor (id) {
    super(id)

    /**
     * @type {Foundation.Form}
     */
    this.form = null

    this.observe("shown", () => {
      if (!this.form) {
        this.form = this.registerForm(new Foundation.Form(this.view.find("form")[0]))
        this.form.setSubmitDelegate(values => this.handleSubmit(values))
        this.observe("hidden", () => this.form.cancelSubmit())
      }
    })
  }

  /**
   * @param {Object.<string,*>} values
   * @return {!Foundation.Promise}
   */
  handleSubmit (values) {
    if (this.form.get('recaptcha')) {
      const result = new Foundation.Promise()

      setTimeout(() => {
        // Notify our parent dialog controller that the user is
        // opting for a "feeling shy" login.
        this.fire('login', values)

        // Not really the way we should be doing this...
        Foundation.Login.Dialog.activeDialog.options["callback"]()

        result.fulfill()
      }, 0)

      return result
    }

    const verifyResult = this.form.get("captcha").verify()
    verifyResult
      .then(() => {
        const shyData = {
          "shyName": values["shyName"],
          "shyEmail": values["shyEmail"],
          "captcha": values["captcha"],
          "captchaVerification": values["captchaVerification"]
        }

        // Notify our parent dialog controller that the user is
        // opting for a "feeling shy" login.
        this.fire("login", shyData)

        // XXX This is the old way of doing it and should be removed in
        //     the future. Keeping it here for a release cycle so things
        //     don't break.
        window["shyData"] = shyData

        // Not really the way we should be doing this...
        Foundation.Login.Dialog.activeDialog.options["callback"]()
      })

    return verifyResult
  }
}
